import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { isEqual } from 'lodash';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Update as UpdateIcon } from '@mui/icons-material';

import { useSelector } from '../../store/utils';
import { useTimeExpiration } from '../../utils/use-time-expiration';

export const AppUpdateOverlay = () => {
  const [updateStartedAt] = useSelector(
    ({ variables }) =>
      [
        variables.APP_UPDATE_STARTED_AT
          ? new Date(variables.APP_UPDATE_STARTED_AT)
          : undefined,
      ] as const,
    isEqual
  );

  const updateExpired = useTimeExpiration(
    updateStartedAt ?? new Date(0),
    600 // 10 minutes
  );

  const isOpen = Boolean(updateStartedAt) && !updateExpired;

  const prevIsOpen = useRef(isOpen);

  useEffect(() => {
    if (prevIsOpen.current && !isOpen) {
      window.location.reload();
    }
    prevIsOpen.current = isOpen;
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            py: 4,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress size={80} thickness={2} />
            <UpdateIcon
              sx={{
                position: 'absolute',
                fontSize: 40,
                color: 'primary.main',
              }}
            />
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              <FormattedMessage
                id="app_update_overlay.title"
                defaultMessage="Aktualizace probíhá"
              />
            </Typography>
            <Typography variant="body1" color="text.secondary">
              <FormattedMessage
                id="app_update_overlay.subtitle"
                defaultMessage="Prosím vyčkejte. Po dokončení aktualizace se aplikace restartuje a okno v prohlížeči se automaticky obnoví"
              />
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
